import { createStore } from '../store';

global.ReduxServer = {
  createStore: (preloadState) => {
    global.LitiumReduxStore = createStore(preloadState);
  },
};
